import React from "react";
import { Link } from "react-router-dom";
import ICONS from "../../../constants/icons";
import {
  BackBtnWrapper,
  BelinsonHeader,
  CardsWrapper,
  TitleWrapper,
  VideosPageWrapper,
} from "../components";
import VideoCard from "../videos-page/VideoCard";
import { videosData } from "./videosData";

const BelinsonVideoPage = () => {
  return (
    <VideosPageWrapper>
      <BelinsonHeader>
        <Link to="/app/belinson">
          <BackBtnWrapper>
            <ICONS.SidebarCloser />
            <div>Back</div>
          </BackBtnWrapper>
        </Link>
        <TitleWrapper>סרטוני הדרכה</TitleWrapper>
      </BelinsonHeader>
      <CardsWrapper>
        {videosData.map((video) => (
          <VideoCard video={video} />
        ))}
      </CardsWrapper>
    </VideosPageWrapper>
  );
};

export default BelinsonVideoPage;
